import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'material-ui/CircularProgress';
import TextField from 'material-ui/TextField';
import theme from 'theme/theme';

const styles = {
    container: {
        flex: '1',
        width: '100%',
    },
    input: {
        width: '100%',
        paddingBottom: '30px',
    },
    counterWrapper: {
        textAlign: 'right',
        marginTop: '-35px',
    },
    counter: {
        marginRight: '10px',
        width: '100%',
        fontWeight: '900',
        transition: 'color .3s ease',
    },
    progress: {
        marginTop: '5px',
        transform: 'rotate(-90deg) translateX(-2px)',
    },
};

class renderTextareaInputField extends React.Component {
    constructor(props) {
        super(props);

        // Setup cursor position for input.
        this.cursor;

        const { input: { value } } = props;

        const charsPercentage = this.calculatePercentage(value);

        this.state = {
            charsRemaining: this.calculateRemaining(value),
            charsPercentage: charsPercentage,
            counterColor: this.changeCounterStyle(charsPercentage),
            value: value,
        };
    }

    componentDidUpdate(prevProps) {
        const { input: { value } } = this.props;

        if (prevProps.input.value !== value) {
            const charsPercentage = this.calculatePercentage(value);
            const counterColor = this.changeCounterStyle(charsPercentage);

            this.setState({
                charsPercentage: charsPercentage,
                charsRemaining: this.calculateRemaining(value),
                counterColor: counterColor,
                value: value,
            });

            this.setCursorPositions();
        }
    }

    handleChange = (newValue) => {
        const { input } = this.props;

        if (newValue === input.value) {
            return;
        }

        const charsPercentage = this.calculatePercentage(newValue);
        const counterColor = this.changeCounterStyle(charsPercentage);

        input.onChange(newValue);

        this.setState({
            charsPercentage: charsPercentage,
            charsRemaining: this.calculateRemaining(newValue),
            counterColor: counterColor,
            value: newValue,
        });
    }

    calculateRemaining = (value) => {
        const { maxLength } = this.props;

        return maxLength - value.length;
    }

    calculatePercentage = (value) => {
        const { maxLength } = this.props;

        let result = 0;

        result = (value.length / maxLength) * 100;

        return result;
    }

    setCursorPositions = () => {
        // Reset the cursor position for input.
        this.textInput.input.refs.input.selectionStart = this.cursor;
        this.textInput.input.refs.input.selectionEnd = this.cursor;
    };

    changeCounterStyle = (percentage) => {
        // Default; No where near the limit, hiding the counter value.
        let counterColor = theme.palette.stardust;

        if (percentage > 100) {
            // Exceeded the limit, making the color red.
            counterColor = theme.palette.deepCarminePink;
        } else if (percentage > 90) {
            // Really close to the limit, changing the colors to a warning yellow/orangish color.
            counterColor = theme.palette.darkOrange;
        } else if (percentage >= 85) {
            // Getting closer to the limit, showing the counter and making it more prominent.
            counterColor = theme.palette.primary1Color;
        }

        return counterColor;
    }

    updateTextInput = (ref) => {
        this.textInput = ref;
    }

    render() {
        const { disabled, fullWidth, input, label, meta: { touched, error }, placeholder, style, type, ...custom } = this.props;
        const { charsRemaining, charsPercentage, counterColor, value } = this.state;

        return (
            <div style={ styles.container }>
                <TextField
                    disabled={ disabled }
                    errorText={ touched && error }
                    floatingLabelText={ label }
                    fullWidth={ fullWidth }
                    hintText={ placeholder }
                    id={ name }
                    onBlur={ input.onBlur }
                    onChange={ (event, value) => {
                        this.cursor = event.target.selectionStart;

                        this.handleChange(value);
                    } }
                    onFocus={ input.onFocus }
                    type={ type }
                    { ...custom }
                    ref={ this.updateTextInput }
                    style={ Object.assign({}, styles.input, style) }
                    value={ value }
                />

                <div
                    style={ Object.assign({}, styles.counterWrapper, style) }
                >
                    <span style={ {
                        ...styles.counter,
                        color: counterColor,
                    } } >
                        { charsRemaining }
                    </span>

                    <CircularProgress
                        style={ styles.progress }
                        color={ counterColor }
                        size={ 14 }
                        thickness={ 1.6 }
                        mode='determinate'
                        value={ charsPercentage }
                    />
                </div>
            </div>
        );
    }
}

renderTextareaInputField.defaultProps = {
    disabled: false,
    fullWidth: false,
};

renderTextareaInputField.propTypes = {
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    input: PropTypes.object,
    label: PropTypes.string,
    maxLength: PropTypes.number,
    meta: PropTypes.object,
    placeholder: PropTypes.string,
    style: PropTypes.object,
    type: PropTypes.string,
};

export default renderTextareaInputField;



// WEBPACK FOOTER //
// ./src/components/form/InputFields/RenderTextareaInputField.js